import React from 'react';
import { Link } from 'react-router-dom';

const base = 'inline-flex items-center justify-center px-8 py-3 rounded-full text-[15px] font-medium transition-all duration-200 min-w-[140px]';

export const PillPrimary = ({ children, to, href, onClick, className = '', type = 'button' }) => {
  const cls = `${base} bg-[#e9dfc0] text-[#2b2b2b] hover:bg-white hover:shadow-md ${className}`;
  if (to) return <Link to={to} className={cls} onClick={onClick}>{children}</Link>;
  if (href) return <a href={href} className={cls} onClick={onClick}>{children}</a>;
  return <button type={type} onClick={onClick} className={cls}>{children}</button>;
};

export const PillOutline = ({ children, to, href, onClick, className = '', type = 'button' }) => {
  const cls = `${base} bg-transparent border border-[#e9dfc0] text-[#e9dfc0] hover:bg-[#e9dfc0] hover:text-[#2b2b2b] ${className}`;
  if (to) return <Link to={to} className={cls} onClick={onClick}>{children}</Link>;
  if (href) return <a href={href} className={cls} onClick={onClick}>{children}</a>;
  return <button type={type} onClick={onClick} className={cls}>{children}</button>;
};

export const PillDark = ({ children, to, href, onClick, className = '' }) => {
  const cls = `${base} bg-[#2b2b2b] text-[#e9dfc0] hover:bg-[#1e1e1e] ${className}`;
  if (to) return <Link to={to} className={cls} onClick={onClick}>{children}</Link>;
  if (href) return <a href={href} className={cls} onClick={onClick}>{children}</a>;
  return <button onClick={onClick} className={cls}>{children}</button>;
};
